import {  FC, useState, useEffect, useMemo, ChangeEvent} from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import { KTSVG } from "../../../smallnation/helpers";
import { Link } from 'react-router-dom';

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import {  useLocation, useHistory } from 'react-router-dom';
import ReactPlayer from 'react-player';

const CompanyVideoUpload: FC = () => {
  const intl = useIntl();
  let history = useHistory();

  const red = "red";
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePrev = () => {
      setActiveIndex(prev =>
         prev === 0 ? videoUrlArr.length - 1 : prev - 1
      );
      //setActiveIndex(0);
      setIsPlaying(false);
   };
 
   const handleNext = () => {
      setActiveIndex(prev =>
         prev === videoUrlArr.length - 1 ? 0 : prev + 1
      );
      //setActiveIndex(0);
      setIsPlaying(false);
   };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyId = queryParams.get('companyId');
  //const companyId = '79';
  const [videoUrl, setVideo] = useState<any>("");
  const [companyDisplayName, setCompanyDisplayName] = useState([]);
  const [defaultVideo, setDefaultVideo] = useState('');

  const [videoUrlArr, setVideoUrlArr] = useState<any[]>([]);

  /*
  const [state, setState] = useState({
     rows: [{}]
  });
  */
  const [state, setState] = useState<any>({
    rows: [{}]
 });

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function getId(url:any) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
      return match[2];
    } else {
      return 'error';
    }
  }

  const getCompanyProfileInfo = (companyId:any) => {
    services.adminGetCompanyProfile(companyId).then((res) => {
      if (res.data) {
        if (res.data.videoUrl == '') {
          setVideo("https://www.youtube.com/embed/Gg1rEy7hClo&t=7s");
        } else {

          //var video_url = res.data.videoUrl;

          //var vidId1 = getId(video_url);
          //console.log(video_url + "---" + vidId1);

          //var embed_videourl1 = "https://www.youtube.com/embed/" + vidId1;
          var embed_videourl1 = res.data.videoUrl;
          // setVideo(res.data.videoUrl);
          setVideo(embed_videourl1);
        }
      }

    });
  }

//####################################
/*function handleChange(idx:any, e:any) {
  const { name, value } = e.target;
  const rows = [...state.rows];
  if(value.trim() != ''){
    $('#emptyvurlMessage').hide();
    rows[idx] = {
      [name]: value
   };
   setState({
      rows
   });
   if(state.rows.length == 1) {
     setDefaultVideo('0-'+value);
   }
   else{
     setDefaultVideo(idx+'-'+value);
   }
  }
 else {
  $('#emptyvurlMessage').show();
 }
  
} */

function handleChange(idx, e) {
  const { name, value } = e.target;
  console.log("------58" + idx);
  const rows = [...state.rows];
  rows[idx] = {
     [name]: value
  };
  setState({
     rows
  });
  console.log(state.rows.length);
  if(state.rows.length == 1) {
     setDefaultVideo('0-'+value);
  }
}

function handleAddRow() {
  $("#vidsuccessMessage").hide();
  $('#defaultvidMessage').hide();
  $('#emptyvurlMessage').hide();
  var emptyfound = 0;
  var rowlength = state.rows.length;
  console.log(rowlength);
  console.log(state.rows);
  for(var i=0; i<rowlength; i++){
    if(state.rows[i].name === ''){
      emptyfound = 1;
    }
  }
  console.log(emptyfound);
  if(rowlength <=2 && emptyfound == 1){
    console.log('1');
    $('#emptyvurlMessage').show();
  } else {
    $('#emptyvurlMessage').hide();
    const item = {
      name: "",
      mobile: ""
   };
   setState({
      rows: [...state.rows, item]
   });
  }
}


function handleAddRowDyn(url:any) {
  const item = {
     name: url,
     mobile: ""
  };
  setState({
     rows: [...state.rows, item]
  });
}


function handleRemoveRow() {
  setState({
     rows: state.rows.slice(0, -1)
  });
}
function handleRemoveSpecificRow(idx:any, vurl:any) {
  $('#defaultvidMessage').hide();
    $('#emptyvurlMessage').hide();
    $("#vidsuccessMessage").hide();
  if(defaultVideo === idx+'-'+vurl){
    setDefaultVideo("");
  }
  const rows = [...state.rows];
  rows.splice(idx, 1);
  setState({ rows });
}

//################################

const getCompanyVideosByCompanyId = (companyId:any) => {
  handleRemoveRow();
  services.getCompanyVideosByCompanyId(companyId).then((res:any) => {
     var vobj = res.data;

     var tempRows = [];
     for (var v = 0; v < vobj.length; v++) {

        var temp = vobj[v].url;


        //var vidId = getId(temp);

        //console.log(temp + "---" + vidId);
        //var embed_videourl = "https://www.youtube.com/embed/" + vidId;
        var embed_videourl = vobj[v].url;

        var item_iter = {
           name: embed_videourl,
           vid: vobj[v].companyVideoId,
           featured: vobj[v].featuredVideo
        };

        if(vobj[v].featuredVideo == 'Y'){
          setDefaultVideo(v+'-'+embed_videourl);
        }
          
        //tempObj.rows.push(item_iter);
        tempRows.push(item_iter);

     }
     if(vobj.length ==0){
      //handleAddRow();
      const item = {
        name: "",
        mobile: ""
     };
      setState({
        rows: [item]
     })
    }else{
      setVideoUrlArr(tempRows);
      var tempObj = {
         rows: tempRows
      };

      setState(tempObj);
    }

    if(vobj.length == 0){
      $("#carouselExampleIndicators").hide();
      $("#carouselExampleIndicators_empty").show();
      $('#carouselExampleIndicators_empty').attr('style','display:block !important');

   }else{
      $("#carouselExampleIndicators").show();
      $("#carouselExampleIndicators_empty").hide();
      $('#carouselExampleIndicators_empty').attr('style','display:none !important');
   }



  });
}

//###############################
  function validateCheck() {
    //alert("test");
  }

  const submitValue = () => {
    var chkValid = true;
    $('#defaultvidMessage').hide();
    $('#emptyvurlMessage').hide();
    $("#vidsuccessMessage").hide();
    const videourls = document.querySelectorAll<HTMLInputElement>('input[name="name"]');
    var checkedval='';
    if(videourls.length == 0){
      var embed_videourl =  $("#videoUrl").val();
      if(embed_videourl){
        const requestObject =
        {
          "companyId": companyId,
          "siteId": 2,
          "videoUrl": embed_videourl
        }
  
        console.log(requestObject);
        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer " + accessTokenIn
            //'Authorization': accessTokenIn
          },
          body: JSON.stringify(requestObject)
        };
        services.admineditCompanyVideo(requestOptions).then((res) => {
          if (res.code == '200') {
            $("#vidsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#vidsuccessMessage").slideUp(500);
            });
            setTimeout(() => {
              getCompanyProfileInfo(companyId);
            }, 1000);
          }
          else {
            $("#vidfailMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#vidfailMessage").slideUp(500);
            });
            setTimeout(() => { }, 1000);
          }
        });
      }
    } else{
      // Loop through radio buttons
      for (let i = 0; i < videourls.length; i++) {
        if (videourls[i].value.trim() == '') {
          chkValid = false;
        }
      }

      if (!chkValid) {
        console.log('2');
        $('#emptyvurlMessage').show();
        return false;
      }
      const radioButtons = document.querySelectorAll<HTMLInputElement>('input[name="default_video"]');
      var checkedval='';
    // Loop through radio buttons
    for (let i = 0; i < radioButtons.length; i++) {
      // Check if the radio button is checked
      if (radioButtons[i].checked) {
        // Return the value of the checked radio button
        checkedval = radioButtons[i].value;
      }
    }
    if(checkedval != ''){
      $('#emptyvurlMessage').hide();
    var vid_url = $("#videoUrl").val();
    var embed_videourl =  $("#videoUrl").val();

    if(embed_videourl){
      const requestObject =
      {
        "companyId": companyId,
        "siteId": 2,
        //"videoUrl": $("#videoUrl").val()
        "videoUrl": embed_videourl
      }
  
      console.log(requestObject);
      var accessTokenIn = sessionStorage.getItem("adminAccToken");
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + accessTokenIn
          //'Authorization': accessTokenIn
        },
        body: JSON.stringify(requestObject)
      };
      services.admineditCompanyVideo(requestOptions).then((res) => {
        if (res.code == '200') {
          $("#vidsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
            $("#vidsuccessMessage").slideUp(500);
          });
          setTimeout(() => {
            //$('#videoUrl').val() = '';
            getCompanyProfileInfo(companyId);
          }, 1000);
        }
        else {
          $("#vidfailMessage").fadeTo(2000, 500).slideUp(500, function () {
            $("#vidfailMessage").slideUp(500);
          });
          setTimeout(() => { }, 1000);
        }
      });
    }
    
  }
  else{
    $('#defaultvidMessage').show();
    return false;
  }
}
  }


  function updateCompanyVideo() {
    $('#defaultvidMessage').hide();
    $('#emptyvurlMessage').hide();
    $('#videoValidMsg').hide();
    $("#vidsuccessMessage").hide();
    $('#vidfailMessage').hide();
    var chkValid = true;
    $('#emptyvurlMessage').hide();
    const videourls = document.querySelectorAll<HTMLInputElement>('input[name="name"]');
  var checkedval='';
  if(videourls.length == 0){
    var urlTempArr = [];
    const requestObject =
    {
       "companyId": companyId,
       "siteId": process.env.React_App_SITE_ID,
       "videoUrl": urlTempArr
    }

    console.log(requestObject);
    var accessTokenIn=sessionStorage.getItem("adminAccToken");
    const requestOptions = {
       method: 'POST',
       headers: {
          'Content-Type': 'application/json',
          // 'Authorization': "Bearer "+accessTokenIn
          //'Authorization': accessTokenIn
       },
       body: JSON.stringify(requestObject)
    };

    services.updateCompanyVideo(requestOptions).then((res) => {
       if(res){
        $("#vidsuccessMessage").show();
        getCompanyVideosByCompanyId(companyId);
       }
    });

  } else{

  
    // Loop through radio buttons
    for (let i = 0; i < videourls.length; i++) {
      // Check if the radio button is checked
      if (videourls[i].value.trim() == '') {
        // Return the value of the checked radio button
        chkValid = false;
      }
    }

    if (!chkValid) {
      console.log('3');
      $('#emptyvurlMessage').show();
       return false;
    }
    console.log('1 - '+defaultVideo);
    const radioButtons = document.querySelectorAll<HTMLInputElement>('input[name="default_video"]');
  var checkedval='';
    // Loop through radio buttons
    for (let i = 0; i < radioButtons.length; i++) {
      // Check if the radio button is checked
      if (radioButtons[i].checked) {
        // Return the value of the checked radio button
        checkedval = radioButtons[i].value;
      }
    }
    console.log(checkedval);
    if(checkedval){
      $('#defaultvidMessage').hide();
    var chkValid = true;
    $('input[name^="name"]').each(function () {
       //code
       var iter_name = $(this).val()
       if (iter_name == "") {
          $(this).addClass("videoInputErrorClass");
          chkValid = false;
       } else {
          $(this).removeClass("videoInputErrorClass");
       }
    });

    if (!chkValid) {
       return false;
    }

    var urlTempArr = [];
    console.log(JSON.stringify(state));
    for (var k = 0; k < state.rows.length; k++) {
      var tname:any =  state.rows[k].name;
      //urlTempArr.push(state.rows[k].name);
      urlTempArr.push(tname);
    }

    const requestObject =
    {
       "companyId": companyId,
       "siteId": process.env.React_App_SITE_ID,
       //"videoUrl": $("#videoUrl").val()
       //"videoUrl": ["v31111","v43333333"]
       "videoUrl": urlTempArr

    }

    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
       method: 'POST',
       headers: {
          'Content-Type': 'application/json',
          // 'Authorization': "Bearer "+accessTokenIn
          //'Authorization': accessTokenIn
       },
       body: JSON.stringify(requestObject)
    };

    services.updateCompanyVideo(requestOptions).then((res) => {
       // navigate('/thankyou');
       //$("#addUserForm").trigger("reset");
       //getCompanyVideo();

      //update default video
      if(checkedval != ''){
        var mydefault = checkedval.split('-');
        const requestObject_defaultvideo =
        {
          "companyId": companyId,
          "url": mydefault[1],
        }

          console.log(requestObject_defaultvideo);
          var accessTokenIn=sessionStorage.getItem("adminAccToken");
          const requestOptions_defaultvideo = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer "+accessTokenIn
                //'Authorization': accessTokenIn
            },
            body: JSON.stringify(requestObject_defaultvideo)
          };

          services.updateCompanyFeaturedVideo(requestOptions_defaultvideo).then((res) => {
            
            // $("#successMessage").show();
            // getCompanyVideosByCompanyId(companyId);
            $("#vidsuccessMessage").show();
       getCompanyVideosByCompanyId(companyId);
          });
        }

       
    });
  } else {
      $('#defaultvidMessage').show();
      return false;
  }
}
 }

  useEffect(() => {
    if (companyId == null || companyId == "null") {
      //navigate('/login');
      history.push('/login');
    }
    $('#defaultvidMessage').hide();
    $('#emptyvurlMessage').hide();
    $('#videoValidMsg').hide();
    $("#vidsuccessMessage").hide();
    $('#vidfailMessage').hide();
    //getCompanyProfileInfo(companyId);
    getCompanyVideosByCompanyId(companyId);
  }, []);

  
 const handleOptionChange = (event: ChangeEvent<HTMLInputElement>) => {
  console.log('value : '+event.target.value);
  setDefaultVideo(event.target.value);
  $('#defaultvidMessage').hide();
};
  return (

    <>
      <PageTitle breadcrumbs={[]}>{companyDisplayName}</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container px-0" style={{maxWidth:"854px"}}>
          <div className="row">

          <h3 className="mb-7">Upload Video</h3>
            {/* <div className="col-lg-12">
              <div className="mb-4">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class=" form-label">Current Video</label>

                </div>
                <iframe width="100%" height="420" src={videoUrl} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

              </div>
            </div> */}

            <div className="col-lg-12">

            <div id="carouselExampleIndicators_empty" className="text-center d-flex align-items-center" style={{ backgroundColor:"#f5f5f5", minHeight:"420px"}}>
              <div className="d-flex flex-column text-center m-auto" style={{width:"220px"}}>
              <img src="/media/icons/duotune/general/no-video.png" className="m-auto mb-2 " style={{maxWidth:"50px"}} alt=""/>
              No videos available

              </div>
            </div>

              <div id="carouselExampleIndicators" className="carousel slide up-vid m-auto" data-bs-ride="false" data-bs-interval="false" style={{maxWidth:"854px", maxHeight:"480px"}}>
                {/* <div className="carousel-indicators">
                  {
                    videoUrlArr.map((data, index) => (
                      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} className={index == 0 ? "active" : " "} aria-current="true" aria-label={"Slide " + index}></button>
                    ))}
                  
                </div>  */}
                <div className="carousel-inner">


                  {
                    videoUrlArr.map((data, index) => (

                      <div className={index == 0 ? "carousel-item active" : "carousel-item "}>
                        {/* <iframe width="100%" height="480" src={data.name} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe> */}
                        <ReactPlayer 
                        url={data.name} 
                        controls={true} 
                        width="100%" 
                        height="480px" 
                        
                        playing={isPlaying && activeIndex === index}
                        onPlay={() => setIsPlaying(true)}
                        config = {
	{
		facebook: {
			attributes: {
				'data-width': 'auto',
				'data-height': 'auto'
			}
		}
	}
} />
                      </div>


                    ))}
                  {/* <div class="carousel-item active">
                                          <iframe width="100%" height="420" src={videoUrl} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                                          </div>
                                          <div class="carousel-item">
                                             <iframe width="100%" height="420" src={videoUrl} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                                          </div>
                                          <div class="carousel-item">
                                             <iframe width="100%" height="420" src={videoUrl} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                                          </div> */}
                </div>
                
 

 
                <button onClick={handlePrev} className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button onClick={handleNext} className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>

            </div>

            {/* <div className="col-lg-12">
              <div className="mb-4">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">Change Video</label>

                </div>
                <input type="text" class="form-control" id="videoUrl" placeholder="" />
                <div id="videoValidMsg" style={{ color: red }} className="error">Video URL is required.</div>
              </div>
            </div> */}

            {/* <div className="col-lg-12">
              <div className="mb-5 px-3">
                <div className="d-flex flex-column ">
                  <div className="row mt-2">
                    <button id="addPerksBtn" type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}> Save</button>
                  </div>
                </div>

              </div>
            </div> */}



            <div className="col-lg-12 mt-10 mb-4" >
              <table
                className="table table-hover vd-ad-rm mb-4"
                id="tab_logic"
              >
                <thead>
                  <tr>
                    <th className="text-center"> <h4>#</h4> </th>
                    <th className="text-center" style={{maxWidth: "50px"}}> <h4>Default Video</h4> </th>

                    <th className="text-center "> <h4>Video URL</h4> </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {state.rows.map((item:any, idx:any) => (
                    <tr id="addr0" key={idx}  style={{verticalAlign:"middle", border:"1" }} >
                      <td className="text-center" >{idx + 1}</td>
                      <td className="text-center"><input className="form-check-input" type="radio" value={idx+'-'+state.rows[idx].name} name="default_video" id={idx+'_default_video'} onChange={handleOptionChange} checked={(defaultVideo === '' || defaultVideo === idx+'-'+state.rows[idx].name)}/>  </td>
                      <td>
                        <input
                          type="text"
                          name="name"
                          id={"name_" + idx}
                          value={state.rows[idx].name}
                          onChange={(e) => handleChange(idx, e)}
                          className="form-control " style={{ lineHeight: "30px" }}
                        />

                        
                      </td>

                      <td style={{ width:"40px", paddingLeft:"0px", textAlign:"center"}}>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleRemoveSpecificRow(idx, state.rows[idx].name)}
                        >
                          <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                          </svg></span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <br />
              <button onClick={() => handleAddRow()} className="btn btn-primary ">
                + Add New
              </button>

              <button onClick={() => updateCompanyVideo()} className="btn btn-primary mx-2">Save</button>
              {/* <button

                                    onClick={() => handleRemoveRow()}
                                    className="btn btn-danger float-right"
                                 >
                                    Delete Last Record
                                 </button> */}
            </div>

            <div id="vidsuccessMessage" className="alert alert-success" role="alert">Video updated successfully</div>
            <div id="defaultvidMessage" className="alert alert-danger" role="alert">Please choose a default video</div>

            <div id="emptyvurlMessage" className="alert alert-danger" role="alert">Please enter video url</div>

            <div id="vidfailMessage" className="alert alert-danger" role="alert">Please try again</div>
          </div>
        </div>
      </form>

    </>
  )
}
export { CompanyVideoUpload }